exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nopadding[data-v-34e92fc2]{padding:0!important;margin:0!important}", ""]);

// exports
